import PropTypes from 'prop-types';
import box from '../../../../assets/images/box.png';
import Text from '../../../../assets/styles/Text';
import Ad from '../../../../components/Ad';
import Loader from '../../../../components/Loader';
import ModalModel from '../../../../components/ModalModel';
import { GENDERS } from '../../../../utils/genders';
import * as styles from './styles';

export default function RenderCards({
  handleGenderChange,
  gender,
  isLoadingModels,
  activeFiltersCount,
  handleClearFilters,
  itemsWithAds,
  isFetchingNextPage,
  hasNextPage,
  allModels,
}) {
  return (
    <>
      <styles.SelectGender>
        {GENDERS.map(({ key, label }) => (
          <button
            key={key}
            type="button"
            onClick={() => handleGenderChange(key)}
            className={gender === key ? 'active' : ''}
            disabled={isLoadingModels}
          >
            <Text.H4>{label}</Text.H4>
          </button>
        ))}
      </styles.SelectGender>

      {/* LOADING INICIAL */}
      {isLoadingModels && <Loader isLoading minimal size={40} />}

      {/* EMPTY STATE */}
      {allModels.length === 0 && !isLoadingModels && (
        <styles.Empty>
          <img src={box} alt="Nenhuma modelo encontrada" />
          <Text.Span $bold>Nenhuma modelo encontrada</Text.Span>
          {activeFiltersCount > 0 && (
            <button type="button" onClick={handleClearFilters}>
              Limpar filtros
            </button>
          )}
        </styles.Empty>
      )}

      {/* MODELOS E ADS */}
      {!isLoadingModels && (
        <styles.GroupPlans>
          {itemsWithAds.map((item) => {
            if (item.type === 'model') {
              return <ModalModel key={item.key} model={item.data} />;
            }
            return (
              <Ad key={item.key} img={item.data.url} link={item.data.link} />
            );
          })}
        </styles.GroupPlans>
      )}

      {/* LOADING MAIS MODELOS */}
      {isFetchingNextPage && (
        <styles.LoadingMore>
          <Loader isLoading minimal size={30} />
          <Text.Span>Carregando mais modelos...</Text.Span>
        </styles.LoadingMore>
      )}

      {/* FIM DAS MODELOS */}
      {!hasNextPage && allModels.length > 0 && (
        <styles.NotHasMoreModel>
          <Text.Span>Todas as modelos foram carregadas</Text.Span>
        </styles.NotHasMoreModel>
      )}
    </>
  );
}

RenderCards.propTypes = {
  handleGenderChange: PropTypes.func.isRequired,
  gender: PropTypes.string.isRequired,
  isLoadingModels: PropTypes.bool.isRequired,
  activeFiltersCount: PropTypes.number.isRequired,
  handleClearFilters: PropTypes.func.isRequired,
  itemsWithAds: PropTypes.array.isRequired,
  isFetchingNextPage: PropTypes.any.isRequired,
  hasNextPage: PropTypes.any.isRequired,
  allModels: PropTypes.array.isRequired,
};
